/*
* 新增广告活动-基础信息
*/
<template>
  <div class="add-base-cell">
    <el-form ref="base" :model="form" :rules="rules" label-width="120px">
      <el-row class="row-cell">
        <el-col :span="10">
          <el-form-item prop="name" label="广告活动名称">
          <template #label>
            <span>广告活动名称</span>
            <gj-help style="padding-left: 3px">	广告活动名称仅对您可见，因此请选择一个您可以轻松识别并在日后参考的名称。</gj-help>
          </template>
            <gj-input v-model="form.name" width="85%" maxlength="30" show-word-limit></gj-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="广告组合">
          <template #label>
            <span>广告组合</span>
            <gj-help style="padding-left: 3px">组合是一组可以设置预算上限的广告活动。组合使您可以对广告活动进行分组和组织。</gj-help>
          </template>
            <gj-select v-model="form.portfolioId" width="180px" placeholder="无广告组合" :options="portfolios"></gj-select>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row class="row-cell">
        <el-col :span="5" class="ad-time">
          <el-form-item prop="startDate">
            <template #label>
              <span>开始时间</span>
              <gj-help style="padding-left: 3px">这是您的广告活动开始的日期。 您可以设置未来的某个日期作为开始日期，以便在该日期开展广告活动。</gj-help>
              <div class="msg">（当地市场时间）</div>
            </template>
            <gj-date-picker :clearable="false" v-model="form.startDate" width="130px" :disabledDate="startDisabledDate"/>
          </el-form-item>
        </el-col>
        <el-col :span="5" class="ad-time">
          <el-form-item prop="endDate">
            <template #label>
              <span>结束时间</span>
              <gj-help style="padding-left: 3px">这是您的广告活动结束的日期。 为确保广告始终投放而不错过曝光或点击机会，请选择“无结束日期”。 您可以在广告活动开展期间随时延长、缩短或结束广告活动。</gj-help>
              <div class="msg">（当地市场时间）</div>
            </template>
            <gj-date-picker :clearable="false" v-model="form.endDate" width="130px" :disabledDate="endDisabledDate"/>
          </el-form-item>
        </el-col>
        <el-col :span="12" v-if="noBrand">
          <el-form-item prop="brandEntityId" label="品牌">
            <template #label>
              品牌
              <gj-help style="padding-left: 3px">	选择一个用于管理广告活动的品牌</gj-help>
            </template>
            <gj-select ref="refSelect" v-model="form.brandEntityId" width="180px" placeholder="请选择品牌" :loading="cOptions.loading.brandEntity" :options="cOptions.brandEntity" @change="brandChange" @focus="brandFocus" :clearable="false"></gj-select>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="12">
          <el-form-item prop="budget" label="预算" style="margin-bottom: 0">
            <template #label>
              <span>预算</span>
              <gj-help style="padding-left: 3px">
                <div>您的预算决定了您在此广告活动上的支出。您可以随时编辑广告活动来更改预算。</div>
                <div>
                  <span style="font-weight: bold"> 每日预算：</span>
                  您愿意每天在此广告活动上花费的金额。如果广告活动支出低于您的每日预算，则剩余金额可用于将日历月其他日期的每日预算提高到 25%。
                </div>
                <div>
                  <span style="font-weight: bold"> 生命周期预算：</span>
                  您愿意在此广告活动上支出的总金额。
                </div>
              </gj-help>
            </template>
            <gj-select v-model="form.budgetType" width="130px" placeholder="请选择预算" :options="options.budgetOptions" :clearable="false" @change="budgetSelectChange"></gj-select>
            <gj-input v-model="form.budget" v-number.price maxlength="12" width="180px">
              <template #prepend>{{ publicObj.SB.currencySymbol }}</template>
            </gj-input>
            <div class="tag" v-show="form.budgetType === 0">（选择生命周期预算方式，必须选择结束时间）</div>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
  </div>
</template>

<script>
import {convertToDate} from "@/utils/date.util";
export default {
    name: 'add-base',
    inject: ['getForms', 'getOptions', 'getLandingPage', 'getBrandListObj', 'formsChange', 'getLogCacheByBrandEntityId', 'getPublicObj'],
    props: {
      noBrand: {
        default: true
      }
    },
    data() {
      return {
        isBrandId: 0, // 0: 没有品牌id， 1：有品牌id
        brandListObj: {},
        addForms: {},
        addAdvertisingFormat: {},
        creative: {},
        form: {},
        options: {
          brandEntity: [], // 品牌
          budgetOptions: [ // 预算枚举
            {id: 1, text: '每日预算'},
            {id: 0, text: '生命周期预算'},
          ]
        },
        rules: {
          name: [
            { required: true, message: '请填写广告活动名称', trigger: ['blur', 'change'] }
          ],
          startDate: [
            { required: true, message: '请选择开始时间', trigger: ['blur', 'change']}
          ],
          endDate: [],
          budget: [
            { required: true, message: '请填写预算', trigger: ['blur', 'change'] }
          ],
          brandEntityId: [
            { required: true, message: '请选择品牌', trigger: ['blur', 'change']}
          ],
        },
        startDisabledDate: (time) => {
          let date = convertToDate(time) + " 23:59:59"
          if (this.maxTime && new Date(date).getTime() <= new Date(this.maxTime).getTime()) {// 按照站点时间计算，时间选项禁用掉过去时间的选择
            return true
          }
          return false
        },
        endDisabledDate: (time) => {
          let date = convertToDate(time) + " 23:59:59"
          if (this.maxTime && new Date(date).getTime() <= new Date(this.maxTime).getTime()) {// 按照站点时间计算，时间选项禁用掉过去时间的选择
            return true
          }
          if (new Date(date).getTime() <= new Date(this.form.startDate).getTime()) {
            return true
          }
          return false
        },
      }
    },
    created() {
      this.addForms = this.getForms()
      this.brandListObj = this.getBrandListObj()
      let { addBase, addAdvertisingFormat, creative } = this.getForms()
      this.form = addBase
      this.creative = creative
      this.addAdvertisingFormat = addAdvertisingFormat
    },
    methods: {
      brandFocus() {
        if (this.form.brandEntityId) {
          // 保存数据
          this.isBrandId = 1
          var addForms = this._.cloneDeep(this.addForms);
          this.brandListObj[this.form.brandEntityId] = addForms
        }
      },
      // 广告切换处理
      brandChange(id) {
        this.getLandingPage(id) // 获取着陆页信息
        this.addForms.creative.brandLogoUrl || this.getLogCacheByBrandEntityId({brandEntityId: id}) // 获取缓存logo
        // 切换数据 当品牌没有选择时不去切换数据
        if (this.isBrandId == 0 ) {
          this.isBrandId = 1
        }else {
          this.formsChange(this.brandListObj[id])
        }
        setTimeout(() => {
          this.$nextTick(() => {
            this.$refs.refSelect.$refs.select.blur()
          })
        }, 96);
      },
      // 预算切换处理
      budgetSelectChange(data) {
        if (data === 0 ) {
          this.form.budget = 100
          this.rules.endDate.push({ required: true, message: '请选择结束时间', trigger: ['blur', 'change'] })
        }else {
          this.form.budget = null
          this.rules.endDate = []
        }
      },
    },
    computed: {
      maxTime() {
        return this.publicObj.SB.market?.datetime
      },
      publicObj() {
        return this.getPublicObj()
      },
      portfolios() {
        return this.publicObj.SB.portfolios.reduce((arr, item) => arr.concat({id: item.portfolioId, text: item.portfolioName}), []) 
      },
      cOptions() {
        return this.getOptions() || {
          loading: {
            brandEntity: false
          },
          brandEntity: []
        }
      }
    },
}
</script>

<style scoped lang="scss">
.add-base-cell {
  position: relative;
}
.row-cell {
  padding-bottom: 6px;
}
/deep/.el-form-item__label {
  color: #333;
}
.ad-time {
  /deep/.el-form-item__label {
    line-height: 1;
    padding-top: 5px;
    .msg {
      padding-top: 3px;
      color: #777;
      transform: scale(.83) translateX(18px);
    }
  }
}
/deep/.gj-select {
  padding-right: 16px;
}
.tag {
  font-size: 12px;
  color: #969696;
  transform: scale(.86) translateX(-63px);
}
</style>